import { IContextCategoryPrice } from "../types/category.interface";
import { createContext } from "react";

const CategoryPriceScreen = createContext<IContextCategoryPrice>({});

export default CategoryPriceScreen;
